<template>
    <div class="goodInOutRecord">
        <div class="query-content">
            <el-form :model="queryformdata" :inline="true" style="margin-bottom: 20px;">
                <el-form-item label="楼 栋" style="margin-right: 30px;" label-width="68px">
                    <el-select v-model="queryformdata.houseId" placeholder="请选择楼栋" style="width:190px;" :disabled="HouseByManagerUserCombobox.length < 2" @change="builidingTreeComboHandleClick">
                        <el-option v-for="item in HouseByManagerUserCombobox" :key="item.houseId" :label="item.houseName" :value="item.houseId">
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="日期" style="margin-right: 8px;">
                    <el-date-picker ref="startTime" :clearable="false" v-model="queryformdata.startTime" type="date" value-format="yyyy-MM-dd" @change="startDateChange" style="width: 200px;">
                    </el-date-picker>

                </el-form-item>
                <el-form-item label="-">
                    <el-date-picker ref="endTime" :clearable="false" v-model="queryformdata.endTime" type="date" value-format="yyyy-MM-dd" :picker-options="endtimepickerOptions" style="width: 200px;">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-input class="input" placeholder="请输入学生姓名、宿舍查询" v-model="queryformdata.nameOrDormitory">
                        <el-button slot="append" icon="el-icon-search" @click="loadDataInFirstPage">查询</el-button>
                    </el-input>
                </el-form-item>
                <el-button class="reset-btn" @click="reset">重置</el-button>
                <div>
                    <el-form-item label="出入类型">
                        <el-select style="width: 190px;" v-model="queryformdata.accessType">
                            <el-option label="全部" :value="''"></el-option>
                            <el-option v-for="(item, index) in accessTypeList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="float: right;margin-right: 20px">

                        <el-button type="primary" class="export-btn el-icon-download" @click="exportExl">导出记录</el-button>
                        <el-button class="sign-btn" @click="showGoodsRecordForm=true">登记</el-button>

                    </div>
                </div>

            </el-form>

        </div>

        <div class="tableList">
            <template>
                <el-table border stripe :data="dataList" header-row-class-name="table-header" style="width: 1200px;">

                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="accessTime" label="时间" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="人员" width="159" align="center">

                    </el-table-column>
                    <el-table-column prop="dormitoryNum" label="宿舍" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="accessType" label="物品出入类型" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="物品" width="400" align="center">

                    </el-table-column>

                    <el-table-column prop="id" label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <span class="operate" @click="deleteRecord(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>

                </el-table>
            </template>
            <div class="pagination-container ">
                <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination" :page="page"></v-pagination>
            </div>
        </div>
        <!--新增来访人员 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="物品出入登记" :visible.sync="showGoodsRecordForm" width="600px" left class="addGoodsRecordForm" :before-close="cancelAddGoodRecordForm">
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span>
                带
                <span class="red">*</span>号的为必填项
            </div>
            <el-form ref="addGoodsRecordForm" :model="addGoodsRecordForm" :rules="addGoodsRecordFormRules" label-width="100px">

                <el-col :span="24">
                    <el-form-item label="学生姓名:" prop="name">
                        <el-input v-model="addGoodsRecordForm.name" maxlength="20" placeholder="最多20字符数" v-inputexclude="'\\s+'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="宿 舍 号:" prop="dormitoryNum">
                        <el-input v-model="addGoodsRecordForm.dormitoryNum" maxlength="20" placeholder="最多20字符数" v-inputexclude="'\\s+'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="物品清单:" prop="goodList">
                        <el-input type="textarea" v-model="addGoodsRecordForm.goodList" style="width: 100%;" placeholder="最多输入200字符" maxlength="200"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="出入类型:" prop="accessType">
                        <el-select style="width: 100%;" v-model="addGoodsRecordForm.accessType">
                            <el-option v-for="(item, index) in accessTypeList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmAddGoodsRecordForm">确定</el-button>
                <el-button @click="cancelAddGoodRecordForm()">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import basetable from '@/mixins/base-table';
import vRules from '@/config/validate_rules';


export default {
    components: {
    },
    props: {},
    mixins: [basetable],
    data () {
        let vm = this;
        return {
            vRules,
            doNotInit: true,
            queryformdata: {
                startTime: '',
                endTime: '',
                nameOrDormitory: '',
                accessType: '',
                houseId: '',
                schoolNum: ''
            },
            endtimepickerOptions: {
                disabledDate (time) {
                    if (vm.queryformdata.startTime) {
                        return time < new Date(vm.queryformdata.startTime + ' 00:00:00').getTime();
                    }
                    return false;
                },
            },
            accessTypeList: [
                { id: 1, text: '进宿舍' },
                { id: 2, text: '出宿舍' }
            ],
            HouseByManagerUserCombobox: [],
            showGoodsRecordForm: false,
            addGoodsRecordForm: {
                name: '',
                room: '',
                accessType: '',
                goodList: '',
                dormitoryNum: ''
            },
            addGoodsRecordFormRules: {
                name: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }, vRules.illegalCharacter],
                dormitoryNum: [{ required: true, message: '请输入宿舍名称', trigger: 'blur' }, vRules.illegalCharacter],
                goodList: [{ required: true, message: '请输入物品清单', trigger: 'blur' }],
                accessType: [{ required: true, message: '请选择出入类型', trigger: 'blur' }]
            }
        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ]),

    },
    methods: {
        builidingTreeComboHandleClick (item) {
            let list = this.HouseByManagerUserCombobox.filter(x => x.houseId === item);
            this.queryformdata.schoolNum = list[0].schoolNum;
        },
        queryHouseByManagerUser () {
            return api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                } else {
                    this.$message(res.message);
                }
                return res.data;
            });
        },
        cancelAddGoodRecordForm (done) {
            this.showGoodsRecordForm = false;
            this.$refs.addGoodsRecordForm.resetFields();
            done && done();
        },
        comfirmAddGoodsRecordForm () {
            this.$refs.addGoodsRecordForm.validate((valid) => {
                if (valid) {
                    let param = {
                        accessType: this.addGoodsRecordForm.accessType,
                        dormitoryNum: this.addGoodsRecordForm.dormitoryNum,
                        name: this.addGoodsRecordForm.name,
                        remark: this.addGoodsRecordForm.goodList,
                        houseId: this.queryformdata.houseId,
                        schoolNum: this.queryformdata.schoolNum
                    }
                    api.accessManage.addGoodInout(param).then((res) => {
                        if (res.code === 0) {
                            this.cancelAddGoodRecordForm();
                            this.loadData();
                        } else {
                            this.$message(res.message);
                        }
                    })
                }
            })
        },
        deleteRecord (id) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
							<p>确认删除该条记录吗？</p>
                        </div>`;

            this.$alert(html, "确认删除?", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定删除",
                showCancelButton: true
            }).then(_ => {
                api.accessManage.delGoodInout(id).then((res) => {
                    if (res.code == 0) {
                        this.loadData();
                    } else {
                        this.$message(res.message);
                    }
                })
            }).catch((e) => { console.log(e) })

        },
        startDateChange (v) {
            this.queryformdata.endTime = v;
        },
        scoreROW (score) {
            if (score > 3) {
                return {
                    class: 'green',
                    text: '优秀'
                }
            }
            if (score === 3) {
                return {
                    class: 'orange',
                    text: '合格'
                }
            } else {
                return {
                    class: 'red',
                    text: '不合格'
                }
            }
        },
        // 返回当天年月日
        _setCurrentTime () {
            let date = new Date();
            let year = date.getFullYear();
            let month = this._padZero(date.getMonth() + 1);
            let day = this._padZero(date.getDate());
            return [year, month, day].join("-");
        },
        _padZero (str) {
            let start = str.length == 2 ? 0 : 1;
            return ("0" + str).substring(start);
        },
        loadData () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            let param = {
                startTime: this.queryformdata.startTime || undefined,
                endTime: this.queryformdata.endTime || undefined,
                accessType: this.queryformdata.accessType || undefined,
                nameOrDormitory: this.queryformdata.nameOrDormitory || undefined,
                houseId: this.queryformdata.houseId + ''
            };
            api.accessManage.getGoodInoutList(param, this.page, this.size).then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.total;
                    this.dataList = data.list;
                } else {
                    this.$message(res.message);
                }
            });
        },
        loadDataInFirstPage () {
            this.page === 1 ? this.loadData() : this.page = 1;
        },
        reset () {
            this.queryformdata = {
                startTime: this._setCurrentTime(),
                endTime: this._setCurrentTime(),
                accessType: '',
                nameOrDormitory: '',
                houseId: this.HouseByManagerUserCombobox[0] && this.HouseByManagerUserCombobox[0].houseId,
                schoolNum: this.HouseByManagerUserCombobox[0] && this.HouseByManagerUserCombobox[0].schoolNum
            };
        },
        exportExl () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            let param = {
                startTime: this.queryformdata.startTime || undefined,
                endTime: this.queryformdata.endTime || undefined,
                accessType: this.queryformdata.accessType || undefined,
                nameOrDormitory: this.queryformdata.nameOrDormitory || undefined,
                houseId: this.queryformdata.houseId + ''
            };
            api.accessManage.exportGoodInoutList(param, this.page, this.size).then((res) => {
                var key, value;
                [key, value] = Object.entries(res.data)[0];
                this.$common.globalExportExl(key, value, '物品出入记录');
            })
        },

    },
    created () {
        this.queryformdata.startTime = this._setCurrentTime();
        this.queryformdata.endTime = this._setCurrentTime();
        this.queryHouseByManagerUser().then((data) => {
            if (data && data.length > 0) {
                this.queryformdata.houseId = data && data[0].houseId;
                this.queryformdata.schoolNum = data && data[0].schoolNum;
            }

            this.loadData();
        })
    },
    mounted () {
    }
}
</script>
<style lang="scss" >
.goodInOutRecord {
  padding: 20px 0;
  .warning-wrapper {
    margin-bottom: 24px;
    line-height: 20px;
  }
  .warning {
    color: #e6a23c;
  }
  .operate {
    color: #26aef3;
    cursor: pointer;
  }
  .input {
    width: 260px;
    float: right;
    margin-top: 5px;
    .el-input__inner {
      border: 1px solid #26aef3;
      border-right: none;
      width: 200px;
    }
    .el-input-group__append {
      border: 1px solid #26aef3;
      border-left: none;
      background-color: #26aef3;
      color: #fff;
    }
  }
  .reset-btn {
    margin-top: 5px;
  }
  .sign-btn {
    width: 60px;
    height: 30px;
    background-color: #ffb324;
    border-color: #ffb324;
    color: #fff;
    margin-top: 5px;
  }
  .export-btn {
    margin-top: 5px;
    border: 1px solid #26aef3;
    color: #26aef3;
    background-color: #fff;
  }
  .green {
    color: #00cdcd;
  }
  .orange {
    color: #ffb324;
  }
  .red {
    color: red;
  }
  .el-form-item {
    display: inline-block;
    height: 40px;
    margin-bottom: 10px;
    margin-right: 20px;
  }
  .query-content {
    margin-bottom: 20px;
  }
  .addGoodsRecordForm {
    form {
      width: 550px;
      margin: 0 auto;
      .el-form-item {
        display: block;
        height: auto;
        margin-bottom: 18px;
      }
    }
    textarea {
        height: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/accessManage/goodInOutRecord.vue